// extracted by mini-css-extract-plugin
export default {"loaderElement":"loader_loaderElement__bP5yR"};